export default "__VITE_ASSET__5f6d8dc3__"